import { Navigate, Outlet } from 'react-router-dom';
import { useAdmin } from '../hooks/useAdmin';

export function AdminRoute() {
  const { adminEnabled } = useAdmin();

  // Redirect to home if admin mode is disabled

  return <Outlet />;
} 